/**
 * W1d (opdracht Frank 22 okt): per koppeling een icoon en een status. PUUR.
 *
 * Status, in deze volgorde van voorrang: een fout van de laatste toets wint, want die
 * is nieuwer dan elke geslaagde ervoor (de backend wist hem bij een geslaagde toets).
 * Een 401 of 403 heet Opnieuw inloggen, elke andere fout Fout. Zonder fout en
 * getoetst: Verbonden. Nooit getoetst: Nog niet getoetst; dat is geen verbinding en
 * ook geen fout, en het scherm hoort dat verschil te laten zien.
 */
export const VERBONDEN = "verbonden";
export const INLOGGEN = "inloggen";
export const FOUT = "fout";
export const NIEUW = "nieuw";

export function koppelStatus(server) {
  if (!server) return NIEUW;
  if (server.fout_soort === "inloggen") return INLOGGEN;
  if (server.fout_soort || server.fout) return FOUT;
  return server.getoetst ? VERBONDEN : NIEUW;
}

/** De tekst bij een status, als vertaalsleutel. */
export const STATUS_TEKST = {
  [VERBONDEN]: "Verbonden",
  [INLOGGEN]: "Opnieuw inloggen",
  [FOUT]: "Fout",
  [NIEUW]: "Nog niet getoetst",
};

//: Tweede niveaus van een landdomein ("co.uk", "com.au"): daar houdt het hogere
//: domein op, want "co.uk" is van niemand.
const TWEEDE_NIVEAU = new Set(["co", "com", "org", "net", "gov", "ac", "edu", "or", "ne", "go"]);

/**
 * W1d2 (glasronde 0.9.191): het domein erboven, of "". PUUR.
 *
 * mcp.direkto.org heeft geen favicon (404); direkto.org wel (via een doorverwijzing
 * naar portal.direkto.org, gemeten 23 oktober 2026). Alleen het EERSTE label eraf,
 * nooit tot een topdomein, nooit tot een tweede niveau als "co.uk", en niet bij een
 * IP-adres. Dezelfde grens als de backend voor een icoon "op het domein erboven".
 */
export function hogerDomein(host) {
  const h = String(host || "").toLowerCase().replace(/\.$/, "");
  if (!h || /^[\d.]+$/.test(h) || h.includes(":")) return "";
  const delen = h.split(".");
  if (delen.length < 3) return "";
  const rest = delen.slice(1);
  if (rest.length === 2 && TWEEDE_NIVEAU.has(rest[0]) && rest[1].length === 2) return "";
  return rest.join(".");
}

/**
 * De bronnen voor het icoon, in volgorde: het icoon van de server zelf, de favicon
 * van zijn eigen host, en (W1d2) die van het domein erboven. Een lokaal programma of
 * een onbruikbaar adres heeft geen bron; dan blijft alleen de letter.
 */
export function icoonBronnen(server) {
  const uit = [];
  if (server?.icoon) uit.push(server.icoon);
  if (server?.soort !== "stdio") {
    try {
      const u = new URL(server?.adres || "");
      if (u.protocol === "https:") {
        uit.push(`https://${u.host}/favicon.ico`);
        const hoger = hogerDomein(u.hostname);
        if (hoger) uit.push(`https://${hoger}/favicon.ico`);
      }
    } catch { /* geen adres: geen favicon */ }
  }
  return uit;
}

/** De letter als laatste terugval: het eerste teken dat een letter of cijfer is. */
export function koppelLetter(naam) {
  const m = String(naam || "").match(/[\p{L}\p{N}]/u);
  return m ? m[0].toUpperCase() : "?";
}
